// extracted by mini-css-extract-plugin
export default {"zoomModal":"H1-z"};